import { useRouterSelector } from '~/hooks/useRouterSelector';
import { getSavedSearchIdFromPath } from '~/utils/PathUtils';

export const useSavedSearchIdSelector = () => {
  return useRouterSelector((location) => getSavedSearchIdFromPath(location.pathname));
};
